import { useNavigate } from "react-router-dom";
import { crossIcon, downloadReport } from "../../asset";
import DownloadButton from "../common/DownloadButton";

interface Props {
  fileUrl: string;
  children?: React.ReactNode;
  className?: string;
  onClose: () => void;
  isCross?: boolean;
  width?: string;
}

export default function AttachmentViewerModal({
  fileUrl,
  onClose,
  isCross = true,
}: Props) {
  const isImage = /\.(jpg|jpeg|png|webp|svg)$/i.test(fileUrl);
  const isPdf = /\.pdf$/i.test(fileUrl);
  const navigate = useNavigate();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate(-1);
    }
  };
  const handleDownload = async () => {
    try {
      const response = await fetch(fileUrl, { mode: "cors" });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileUrl.split("/").pop() || "download";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed:", error);

      // fallback
      window.open(fileUrl, "_blank");
    }
  };

  return (
    <div className="fixed w-full h-full bg-black/40 left-0 top-0 z-50 flex items-center justify-center px-2 ">
      <div
        className="w-full h-full absolute left-0 top-0 z-10 "
        onClick={handleClose}
      ></div>
      <div className="relative max-w-5xl bg-white max-h-[70vh] rounded-3xl ">
        <div
          className="bg-white rounded-full w-10 h-10 flex items-center justify-center
             absolute -top-14 right-3 z-30 cursor-pointer shadow"
          onClick={handleClose}
        >
          <img src={crossIcon} alt="Close" />
        </div>

        {isImage && (
          <div className="relative rounded-3xl">
            <img
              src={fileUrl}
              alt="Attachment"
              className="w-full min-h-[350px] max-h-[70vh] p-2 rounded-3xl object-contain overflow-hidden"
            />

            <div className="absolute bottom-4 right-4 z-30">
              <button
                onClick={handleDownload}
                className="flex items-center gap-2 px-3 py-[6px] rounded 
                 bg-success-800 text-white text-[13px] font-semibold
                 hover:bg-success-700 disabled:opacity-50"
              >
                <img src={downloadReport} alt="" />
                Download
              </button>
            </div>
          </div>
        )}

        {isPdf && (
          <div className="relative w-full h-full">
            <div className="absolute top-3 right-14 z-30">
              <button
                onClick={handleDownload}
                className="flex items-center gap-2 px-3 py-[6px] rounded 
                 bg-success-800 text-white text-[13px] font-semibold
                 hover:bg-success-700 disabled:opacity-50"
              >
                <img src={downloadReport} alt="" />
                Download
              </button>
            </div>

            <iframe
              src={fileUrl}
              className="w-full h-full rounded-3xl"
              title="Attachment PDF"
            />
          </div>
        )}

        {!isImage && !isPdf && (
          <div className="flex items-center justify-center h-full text-white">
            Unsupported file type
          </div>
        )}
      </div>
    </div>
  );
}
